import { useEffect } from 'react';
import { useUser } from '@clerk/clerk-react';
import posthog from 'posthog-js';

export const usePostHogIdentification = () => {
    const { isSignedIn, user } = useUser();

    useEffect(() => {
        if (isSignedIn && user && posthog.__loaded) {
            // Identify user in PostHog
            posthog.identify(user.id, {
                email: user.primaryEmailAddress?.emailAddress,
                firstName: user.firstName,
                lastName: user.lastName,
                username: user.username,
                createdAt: user.createdAt,
            });

            // Set user properties
            posthog.people.set({
                email: user.primaryEmailAddress?.emailAddress,
                name: `${user.firstName} ${user.lastName}`,
            });

            if (import.meta.env.DEV) {
                console.log('User identified in PostHog:', user.id);
            }
        } else if (!isSignedIn && posthog.__loaded) {
            // Reset PostHog on logout
            posthog.reset();

            if (import.meta.env.DEV) {
                console.log('PostHog reset - user logged out');
            }
        }
    }, [isSignedIn, user]);
};
